import React, { Component } from 'react'

export default class TargetSelect extends Component {
    render() {
        const {options, onChange, showCorrect, answer,correctAnswer} = this.props;
    return (
     showCorrect? <button disabled className={`btn btn-target-select text-white fw-bold ${(answer===correctAnswer)?'bg-success':'bg-danger'}`}>{answer}</button>: 
    <select onChange={onChange} className="form-select form-select-inline d-inline" style={{width:'150px'}} aria-label="select word">
     { ['Select a word',...options].map(o => <option value={o}>{o}</option>)}
      
    </select>
    )
  }
}
